import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 * Fires on the sitter profile revamp when the "More services" (all services)
 * accordion section is expanded.
 *
 * &nbsp;
 */
export class SitterProfileAllServiceExpandEvent extends AnalyticsEvent {
  eventName = 'sitter-profile-all-service-expand';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;
}
